import React from "react";
import CustomDrawer from "./CustomDrawer";
import "./index.scss";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";

interface Props {
  display: boolean;
  onChangeDisplay: () => void;
  errorMessage: string;
  isRedirect: boolean;
  isExpired?: boolean;
}

const ErrorPopupComponent: React.FunctionComponent<Props> = ({
  display,
  onChangeDisplay,
  errorMessage,
  isRedirect,
  isExpired,
}: Props) => {
  const { REACT_APP_URL_REDIRECT_GAME } = process.env;

    let redirectUrl: string;
    if(isExpired){
        redirectUrl = REACT_APP_URL_REDIRECT_GAME || '';
    }else{
        redirectUrl = `/`;
    }

  const handleErrorStatus = () => {
    if (isRedirect) window.location.href = redirectUrl;
  };

  return (
    <CustomDrawer
      isOpen={display}
      onClose={() => {
        onChangeDisplay();
        handleErrorStatus();
      }}
    >
      <div
        style={{
          maxHeight: "500px !important",
          margin: "0px !important",
          zIndex: "500 !important",
        }}>
        <div
          className="drawerErrorPopupHeader"
          style={{
            position: "sticky",
            top: 0,
            right: 0,
            left: 0,
            background: "white",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "10px",
            zIndex: 1,
          }}
          onTouchMove={(e) => {
            if (display) {
              onChangeDisplay();
              handleErrorStatus();
            }
          }}
        >
          <div
            style={{
              width: "5%",
              border: "2px solid var(--border-card)",
              borderRadius: "16px",
              marginBottom: "2rem",
            }}
          ></div>
          <ErrorOutlineRoundedIcon color="error" style={{ fontSize: "5rem" }} />
        </div>
        <div
          className="drawerContent"
          style={{
            maxHeight: "450px",
            overflowY: "auto",
            paddingTop: "10px",
            paddingLeft: "50px",
            paddingRight: "50px",
            paddingBottom: "10px",
            marginTop: "0px",
          }}
        >
          <div
            className="drawerTitle"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              paddingBottom: "2rem",
            }}>
            <div
              className="errorPopupTitle"
              style={{
                fontSize: "16px !important",
                fontWeight: "bold",
                textAlign: "center",
                marginBottom: "1rem",
              }}
            >
              Info
            </div>
            <div
              className="errorPopupSubtitle"
              style={{
                fontSize: "14px !important",
                textAlign: "center",
                marginBottom: "2rem",
                paddingLeft: "2rem",
                paddingRight: "2rem",
              }}
            >
              {errorMessage && errorMessage.toLowerCase() === "invalid jwt"
                ? "Your session is ended. Please back to home apps."
                : errorMessage}
            </div>
          </div>
        </div>
      </div>
    </CustomDrawer>
  );
};

export default ErrorPopupComponent;
